import { useEffect, useRef, useState } from 'react';
import { Link, useParams } from 'react-router-dom';

import ROUTES from '../../routes';
import api from '../../config/axiosInstance';
import { showToast } from '../../utils/toast';
import { handleErrors } from '../../utils/common';

const ProjectCMS = () => {
    const { code } = useParams();
    const formRef = useRef();

    const [submitting, setSubmitting] = useState(false);

    const [formData, setFormData] = useState({
        title: '',
        contact_title: ''
    });

    const [contactImg, setContactImg] = useState(null);
    const [contactImgPreview, setContactImgPreview] = useState(null);

    const handleChange = e => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleImageChange = e => {
        const file = e.target.files[0];
        if (file) {
            setContactImg(file);
            setContactImgPreview(URL.createObjectURL(file));
        }
    };

    useEffect(() => {
        const fetchCMS = async () => {
            try {
                const res = await api.get(`/cms/${code}`);
                if (res.status === 200) {
                    const data = res.data.cms;
                    setFormData({
                        title: data.title || '',
                        contact_title: data.contact_title || ''
                    });
                    setContactImgPreview(data.contact_image ? `${res.data.base_url}${data.contact_image}` : null);
                }
            } catch (err) {
                handleErrors(err);
            }
        };

        fetchCMS();

        if (formRef.current && window.$.fn.validate) {
            window.$(formRef.current).validate({
                ignore: ".ck-editor *",
                rules: {
                    title: { required: true },
                    contact_title: { required: true }
                },
                messages: {
                    title: { required: 'Title is required' },
                    contact_title: { required: 'Contact title is required' }
                },
                errorElement: "label",
                validClass: "is-valid",
                errorClass: "is-invalid text-danger",
                highlight: function (element, errorClass, validClass) {
                    $(element).addClass(errorClass).removeClass(validClass);
                },
                unhighlight: function (element, errorClass, validClass) {
                    $(element).removeClass(errorClass).addClass(validClass);
                }
            });
        }
    }, [code]);

    const handleFormSubmit = async () => {
        const $ = window.jQuery;
        const form = $(formRef.current);

        if (form.valid()) {
            const data = new FormData();
            Object.entries(formData).forEach(([key, value]) => data.append(key, value));
            if (contactImg) data.append("contact_image", contactImg);

            try {
                setSubmitting(true);
                const res = await api.put(`/cms/${code}`, data, {
                    headers: { "Content-Type": "multipart/form-data" }
                });
                showToast("success", res.data.message, "Success");
            } catch (err) {
                handleErrors(err);
            } finally {
                setSubmitting(false);
            }
        }
    };

    return (
        <>
            <div className="page-titles">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to={ROUTES.ROOT}>Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active">
                        <Link to={`/cms/project`}>Project Page</Link>
                    </li>
                </ol>
            </div>
            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header">
                            <h4 className="card-title">Project Page</h4>
                        </div>
                        <div className="card-body">
                            <form ref={formRef} noValidate>
                                <div className="row">

                                    {[
                                        { name: 'title', label: 'Title' },
                                        { name: 'contact_title', label: 'Contact Title' }
                                    ].map(({ name, label }) => (
                                        <div className="mb-3 col-lg-6 col-md-6 col-sm-6" key={name}>
                                            <label className="form-label">
                                                {label}
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name={name}
                                                value={formData[name]}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    ))}

                                    <div className="mb-3 col-lg-6 col-md-6 col-sm-6">
                                        <label>Contact Image</label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            onChange={handleImageChange}
                                        />
                                        {contactImgPreview && (
                                            <img src={contactImgPreview} alt="Preview" width={100} className="mt-2" />
                                        )}
                                    </div>
                                </div>

                                <div className="pt-3">
                                    <button 
                                        type="button"
                                        onClick={handleFormSubmit}
                                        className="btn btn-sm btn-primary me-2"
                                        disabled={submitting}
                                    >
                                        {submitting ? (
                                            <>
                                                <i className="spinner-border spinner-border-sm me-1"></i>
                                                Submit
                                            </>
                                        ) : (
                                            <>
                                                <i className="fa fa-floppy-disk me-1"></i>
                                                Submit
                                            </>
                                        )}
                                    </button>
                                    <Link to={ROUTES.ROOT} className="btn btn-sm btn-danger light">
                                        <i className="fas fa-times-circle"></i>&nbsp;
                                        Cancel
                                    </Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ProjectCMS;